/**
 * 环境检测
 * @author zhengwj
 */
const detect = {}
const isBrowser = typeof navigator !== 'undefined'

if (isBrowser) {
  const ua = navigator.userAgent

  detect.ua = ua

  detect.isAndroid = ua.indexOf('Android') > -1

  detect.isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  detect.isIPhone = ua.indexOf('iPhone') > -1

  // detect.isIPhonex = detect.isIPhone && (window.screen.width * window.screen.height === 304500)

  detect.isWeixin = ua.toLowerCase().indexOf('micromessenger') > -1

  detect.isQQ = ua.toLocaleLowerCase().indexOf(' qq') !== -1

  detect.isPC = !detect.isIOS && !detect.isAndroid
}

export default detect
